import React from 'react';

const DesignSystemDemo = () => {
  return (
    <div className="p-custom-8 bg-secondary min-h-screen">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md mb-custom-8">
          <h1 className="text-4xl font-bold text-brand-primary mb-custom-2">
            🎨 Therapy AI Design System
          </h1>
          <p className="text-secondary text-lg">
            Uppdaterat designsystem med nya färgpaletter: Primary, Gray (ren gråskala) och Brand Tertiary (varm lila-tonad)
          </p>
        </div>

        {/* Colors Section */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md mb-custom-6">
          <h2 className="text-2xl font-semibold text-primary mb-custom-4">Färger</h2>
          
          {/* Primary Colors */}
          <div className="mb-custom-6">
            <h3 className="text-lg font-medium text-secondary mb-custom-3">Primary Colors</h3>
            <div className="grid grid-cols-6 gap-custom-2">
              <div className="text-center">
                <div className="bg-primary-50 h-12 radius-custom-md mb-custom-2 border border-light"></div>
                <p className="text-xs text-tertiary">50</p>
                <p className="text-xs text-tertiary font-mono">#fefafb</p>
              </div>
              <div className="text-center">
                <div className="bg-primary-200 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">200</p>
                <p className="text-xs text-tertiary font-mono">#f7d1dd</p>
              </div>
              <div className="text-center">
                <div className="bg-primary-400 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">400</p>
                <p className="text-xs text-tertiary font-mono">#e87ea2</p>
              </div>
              <div className="text-center">
                <div className="bg-primary-600 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">600</p>
                <p className="text-xs text-tertiary font-mono">#b52052</p>
              </div>
              <div className="text-center">
                <div className="bg-primary-800 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">800</p>
                <p className="text-xs text-tertiary font-mono">#460c20</p>
              </div>
              <div className="text-center">
                <div className="bg-primary-950 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">950</p>
                <p className="text-xs text-tertiary font-mono">#2b0814</p>
              </div>
            </div>
          </div>

          {/* Gray Colors (New Pure Grayscale) */}
          <div className="mb-custom-6">
            <h3 className="text-lg font-medium text-secondary mb-custom-3">Gray Colors (Pure Grayscale)</h3>
            <div className="grid grid-cols-6 gap-custom-2">
              <div className="text-center">
                <div className="bg-gray-50 h-12 radius-custom-md mb-custom-2 border border-light"></div>
                <p className="text-xs text-tertiary">50</p>
                <p className="text-xs text-tertiary font-mono">#fafafa</p>
              </div>
              <div className="text-center">
                <div className="bg-gray-200 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">200</p>
                <p className="text-xs text-tertiary font-mono">#e4e4e7</p>
              </div>
              <div className="text-center">
                <div className="bg-gray-400 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">400</p>
                <p className="text-xs text-tertiary font-mono">#a1a1aa</p>
              </div>
              <div className="text-center">
                <div className="bg-gray-600 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">600</p>
                <p className="text-xs text-tertiary font-mono">#52525b</p>
              </div>
              <div className="text-center">
                <div className="bg-gray-800 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">800</p>
                <p className="text-xs text-tertiary font-mono">#27272a</p>
              </div>
              <div className="text-center">
                <div className="bg-gray-950 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">950</p>
                <p className="text-xs text-tertiary font-mono">#09090b</p>
              </div>
            </div>
          </div>

          {/* Brand Tertiary Colors (Previous Purple-tinted Gray) */}
          <div className="mb-custom-6">
            <h3 className="text-lg font-medium text-secondary mb-custom-3">Brand Tertiary Colors (Warm Purple-tinted)</h3>
            <div className="grid grid-cols-6 gap-custom-2">
              <div className="text-center">
                <div style={{backgroundColor: 'var(--brand-tertiary-50)'}} className="h-12 radius-custom-md mb-custom-2 border border-light"></div>
                <p className="text-xs text-tertiary">50</p>
                <p className="text-xs text-tertiary font-mono">#fbfbfd</p>
              </div>
              <div className="text-center">
                <div style={{backgroundColor: 'var(--brand-tertiary-200)'}} className="h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">200</p>
                <p className="text-xs text-tertiary font-mono">#dddbec</p>
              </div>
              <div className="text-center">
                <div style={{backgroundColor: 'var(--brand-tertiary-400)'}} className="h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">400</p>
                <p className="text-xs text-tertiary font-mono">#a19bca</p>
              </div>
              <div className="text-center">
                <div style={{backgroundColor: 'var(--brand-tertiary-600)'}} className="h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">600</p>
                <p className="text-xs text-tertiary font-mono">#514889</p>
              </div>
              <div className="text-center">
                <div style={{backgroundColor: 'var(--brand-tertiary-800)'}} className="h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">800</p>
                <p className="text-xs text-tertiary font-mono">#1f1c35</p>
              </div>
              <div className="text-center">
                <div style={{backgroundColor: 'var(--brand-tertiary-950)'}} className="h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-xs text-tertiary">950</p>
                <p className="text-xs text-tertiary font-mono">#141221</p>
              </div>
            </div>
          </div>

          {/* Brand Colors */}
          <div className="mb-custom-6">
            <h3 className="text-lg font-medium text-secondary mb-custom-3">Brand Colors</h3>
            <div className="grid grid-cols-3 gap-custom-4">
              <div className="text-center">
                <div className="bg-brand-primary h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-sm text-tertiary">Primary</p>
                <p className="text-xs text-tertiary font-mono">#b52052</p>
              </div>
              <div className="text-center">
                <div className="bg-brand-secondary h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-sm text-tertiary">Secondary</p>
                <p className="text-xs text-tertiary font-mono">#b76d68</p>
              </div>
              <div className="text-center">
                <div className="bg-brand-accent h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-sm text-tertiary">Accent</p>
                <p className="text-xs text-tertiary font-mono">#f5dfbb</p>
              </div>
            </div>
          </div>

          {/* Semantic Colors */}
          <div className="mb-custom-6">
            <h3 className="text-lg font-medium text-secondary mb-custom-3">Semantic Colors</h3>
            <div className="grid grid-cols-4 gap-custom-4">
              <div className="text-center">
                <div className="bg-success-500 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-sm text-tertiary">Success</p>
                <p className="text-xs text-tertiary font-mono">#22c55e</p>
              </div>
              <div className="text-center">
                <div className="bg-warning-500 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-sm text-tertiary">Warning</p>
                <p className="text-xs text-tertiary font-mono">#f97316</p>
              </div>
              <div className="text-center">
                <div className="bg-error-500 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-sm text-tertiary">Error</p>
                <p className="text-xs text-tertiary font-mono">#dc2626</p>
              </div>
              <div className="text-center">
                <div className="bg-info-500 h-12 radius-custom-md mb-custom-2"></div>
                <p className="text-sm text-tertiary">Info</p>
                <p className="text-xs text-tertiary font-mono">#b76d68</p>
              </div>
            </div>
          </div>
        </div>

        {/* Complete Color Palettes with Hex Codes */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md mb-custom-6">
          <h2 className="text-2xl font-semibold text-primary mb-custom-4">Kompletta Färgpaletter med Hexkoder</h2>
          
          {/* Complete Primary Palette */}
          <div className="mb-custom-6">
            <h3 className="text-lg font-medium text-secondary mb-custom-3">Primary Palette (Rosa/Röd)</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-custom-3">
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-50 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">primary-50</p>
                <p className="text-xs font-mono text-tertiary">#fefafb</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-100 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">primary-100</p>
                <p className="text-xs font-mono text-tertiary">#fbeaf0</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-200 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">primary-200</p>
                <p className="text-xs font-mono text-tertiary">#f7d1dd</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-300 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">primary-300</p>
                <p className="text-xs font-mono text-tertiary">#f0adc3</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-400 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">primary-400</p>
                <p className="text-xs font-mono text-tertiary">#e87ea2</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-500 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">primary-500</p>
                <p className="text-xs font-mono text-tertiary">#de4679</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-600 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">primary-600</p>
                <p className="text-xs font-mono text-gray-300">#b52052</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-700 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">primary-700</p>
                <p className="text-xs font-mono text-gray-300">#68122f</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-800 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">primary-800</p>
                <p className="text-xs font-mono text-gray-300">#460c20</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-900 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">primary-900</p>
                <p className="text-xs font-mono text-gray-300">#320917</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-primary-950 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">primary-950</p>
                <p className="text-xs font-mono text-gray-300">#2b0814</p>
              </div>
            </div>
          </div>

          {/* Complete Gray Palette */}
          <div className="mb-custom-6">
            <h3 className="text-lg font-medium text-secondary mb-custom-3">Gray Palette (Ren Gråskala)</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-custom-3">
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-50 h-16 radius-custom-md mb-custom-2 border border-gray-200"></div>
                <p className="text-xs font-semibold">gray-50</p>
                <p className="text-xs font-mono text-tertiary">#fafafa</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-100 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">gray-100</p>
                <p className="text-xs font-mono text-tertiary">#f4f4f5</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-200 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">gray-200</p>
                <p className="text-xs font-mono text-tertiary">#e4e4e7</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-300 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">gray-300</p>
                <p className="text-xs font-mono text-tertiary">#d4d4d8</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-400 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">gray-400</p>
                <p className="text-xs font-mono text-gray-200">#a1a1aa</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-500 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">gray-500</p>
                <p className="text-xs font-mono text-gray-200">#71717a</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-600 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">gray-600</p>
                <p className="text-xs font-mono text-gray-200">#52525b</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-700 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">gray-700</p>
                <p className="text-xs font-mono text-gray-200">#3f3f46</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-800 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">gray-800</p>
                <p className="text-xs font-mono text-gray-200">#27272a</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-900 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">gray-900</p>
                <p className="text-xs font-mono text-gray-200">#18181b</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div className="bg-gray-950 h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">gray-950</p>
                <p className="text-xs font-mono text-gray-200">#09090b</p>
              </div>
            </div>
          </div>

          {/* Complete Brand Tertiary Palette */}
          <div className="mb-custom-6">
            <h3 className="text-lg font-medium text-secondary mb-custom-3">Brand Tertiary Palette (Lila-tonad)</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-custom-3">
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#fbfbfd'}} className="h-16 radius-custom-md mb-custom-2 border border-gray-200"></div>
                <p className="text-xs font-semibold">tertiary-50</p>
                <p className="text-xs font-mono text-tertiary">#fbfbfd</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#f0eff7'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">tertiary-100</p>
                <p className="text-xs font-mono text-tertiary">#f0eff7</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#dddbec'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">tertiary-200</p>
                <p className="text-xs font-mono text-tertiary">#dddbec</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#c3bfdd'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold">tertiary-300</p>
                <p className="text-xs font-mono text-tertiary">#c3bfdd</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#a19bca'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">tertiary-400</p>
                <p className="text-xs font-mono text-gray-200">#a19bca</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#776eb3'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">tertiary-500</p>
                <p className="text-xs font-mono text-gray-200">#776eb3</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#514889'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">tertiary-600</p>
                <p className="text-xs font-mono text-gray-200">#514889</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#2d284d'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">tertiary-700</p>
                <p className="text-xs font-mono text-gray-200">#2d284d</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#1f1c35'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">tertiary-800</p>
                <p className="text-xs font-mono text-gray-200">#1f1c35</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#171426'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">tertiary-900</p>
                <p className="text-xs font-mono text-gray-200">#171426</p>
              </div>
              <div className="bg-white p-custom-3 radius-custom-md border border-light">
                <div style={{backgroundColor: '#141221'}} className="h-16 radius-custom-md mb-custom-2"></div>
                <p className="text-xs font-semibold text-white">tertiary-950</p>
                <p className="text-xs font-mono text-gray-200">#141221</p>
              </div>
            </div>
          </div>
        </div>

        {/* Color Usage Examples */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md mb-custom-6">
          <h2 className="text-2xl font-semibold text-primary mb-custom-4">Färganvändning i Praktiken</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-custom-6">
            {/* Primary Usage */}
            <div className="bg-primary-50 p-custom-4 radius-custom-lg border border-primary-200">
              <h3 className="text-primary-600 font-semibold mb-custom-2">Primary Palette</h3>
              <p className="text-primary-800 text-sm mb-custom-3">Används för huvudfärger, CTA-knappar och viktiga element</p>
              <button className="bg-primary-600 text-white px-custom-4 py-custom-2 radius-custom-md text-sm">
                Call to Action
              </button>
            </div>

            {/* Gray Usage */}
            <div className="bg-gray-50 p-custom-4 radius-custom-lg border border-gray-200">
              <h3 className="text-gray-700 font-semibold mb-custom-2">Gray Palette</h3>
              <p className="text-gray-600 text-sm mb-custom-3">Ren gråskala för neutrala element och text</p>
              <div className="bg-gray-100 p-custom-2 radius-custom-md">
                <span className="text-gray-800 text-sm">Neutral innehåll</span>
              </div>
            </div>

            {/* Brand Tertiary Usage */}
            <div style={{backgroundColor: 'var(--brand-tertiary-50)', borderColor: 'var(--brand-tertiary-200)'}} className="p-custom-4 radius-custom-lg border">
              <h3 style={{color: 'var(--brand-tertiary-700)'}} className="font-semibold mb-custom-2">Brand Tertiary</h3>
              <p style={{color: 'var(--brand-tertiary-600)'}} className="text-sm mb-custom-3">Varm, lila-tonad palett för mjukare element</p>
              <div style={{backgroundColor: 'var(--brand-tertiary-100)'}} className="p-custom-2 radius-custom-md">
                <span style={{color: 'var(--brand-tertiary-800)'}} className="text-sm">Mjuka accenter</span>
              </div>
            </div>
          </div>
        </div>

        {/* Typography Section */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md mb-custom-6">
          <h2 className="text-2xl font-semibold text-primary mb-custom-4">Typografi</h2>
          
          <div className="space-y-custom-3">
            <h1 className="text-6xl font-bold text-primary">Heading 1 (6xl)</h1>
            <h2 className="text-4xl font-bold text-primary">Heading 2 (4xl)</h2>
            <h3 className="text-2xl font-semibold text-primary">Heading 3 (2xl)</h3>
            <h4 className="text-xl font-medium text-primary">Heading 4 (xl)</h4>
            <p className="text-base text-secondary font-normal">
              Normal text (base) - Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </p>
            <p className="text-sm text-tertiary">
              Small text (sm) - Används för mindre viktig information
            </p>
          </div>
        </div>

        {/* Buttons Section */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md mb-custom-6">
          <h2 className="text-2xl font-semibold text-primary mb-custom-4">Knappar</h2>
          
          <div className="space-y-custom-4">
            {/* Primary Buttons */}
            <div>
              <h3 className="text-lg font-medium text-secondary mb-custom-3">Primary Buttons</h3>
              <div className="flex gap-custom-3 flex-wrap">
                <button className="bg-brand-primary text-inverse px-custom-3 py-custom-2 text-sm radius-custom-sm transition-custom hover:bg-brand-primary-dark">
                  Small
                </button>
                <button className="bg-brand-primary text-inverse px-custom-6 py-custom-3 text-base radius-custom-md transition-custom hover:bg-brand-primary-dark">
                  Medium
                </button>
                <button className="bg-brand-primary text-inverse px-custom-8 py-custom-4 text-lg radius-custom-lg transition-custom hover:bg-brand-primary-dark">
                  Large
                </button>
              </div>
            </div>

            {/* Secondary Buttons */}
            <div>
              <h3 className="text-lg font-medium text-secondary mb-custom-3">Secondary Buttons</h3>
              <div className="flex gap-custom-3 flex-wrap">
                <button className="bg-neutral-200 text-primary px-custom-6 py-custom-3 radius-custom-md transition-custom hover:bg-neutral-300">
                  Secondary
                </button>
                <button className="border border-brand-primary text-brand-primary px-custom-6 py-custom-3 radius-custom-md transition-custom hover:bg-brand-primary hover:text-inverse">
                  Outline
                </button>
              </div>
            </div>

            {/* Semantic Buttons */}
            <div>
              <h3 className="text-lg font-medium text-secondary mb-custom-3">Semantic Buttons</h3>
              <div className="flex gap-custom-3 flex-wrap">
                <button className="bg-success-500 text-inverse px-custom-6 py-custom-3 radius-custom-md transition-custom hover:bg-success-600">
                  Success
                </button>
                <button className="bg-warning-500 text-inverse px-custom-6 py-custom-3 radius-custom-md transition-custom hover:bg-warning-600">
                  Warning
                </button>
                <button className="bg-error-500 text-inverse px-custom-6 py-custom-3 radius-custom-md transition-custom hover:bg-error-600">
                  Error
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Cards Section */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md mb-custom-6">
          <h2 className="text-2xl font-semibold text-primary mb-custom-4">Cards & Shadows</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-custom-6">
            <div className="bg-primary border border-light p-custom-4 radius-custom-md shadow-custom-sm">
              <h3 className="font-semibold text-primary mb-custom-2">Small Shadow</h3>
              <p className="text-secondary text-sm">Lätt skugga för subtila kort</p>
            </div>
            <div className="bg-primary border border-light p-custom-4 radius-custom-md shadow-custom-md">
              <h3 className="font-semibold text-primary mb-custom-2">Medium Shadow</h3>
              <p className="text-secondary text-sm">Standard skugga för huvudkort</p>
            </div>
            <div className="bg-primary border border-light p-custom-4 radius-custom-md shadow-custom-lg">
              <h3 className="font-semibold text-primary mb-custom-2">Large Shadow</h3>
              <p className="text-secondary text-sm">Stark skugga för betonade element</p>
            </div>
          </div>
        </div>

        {/* Form Elements */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md mb-custom-6">
          <h2 className="text-2xl font-semibold text-primary mb-custom-4">Formulärelement</h2>
          
          <div className="space-y-custom-4 max-w-md">
            <div>
              <label className="block text-sm font-medium text-secondary mb-custom-2">
                Textfält
              </label>
              <input 
                type="text" 
                placeholder="Skriv något..."
                className="w-full px-custom-3 py-custom-2 border border-light radius-custom-md bg-primary text-primary transition-custom focus:outline-none focus:ring-2 focus:ring-border-focus"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-secondary mb-custom-2">
                Dropdown
              </label>
              <select className="w-full px-custom-3 py-custom-2 border border-light radius-custom-md bg-primary text-primary transition-custom focus:outline-none focus:ring-2 focus:ring-border-focus">
                <option>Välj ett alternativ</option>
                <option>Alternativ 1</option>
                <option>Alternativ 2</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-secondary mb-custom-2">
                Textarea
              </label>
              <textarea 
                rows="3" 
                placeholder="Längre text..."
                className="w-full px-custom-3 py-custom-2 border border-light radius-custom-md bg-primary text-primary transition-custom focus:outline-none focus:ring-2 focus:ring-border-focus"
              ></textarea>
            </div>
          </div>
        </div>

        {/* Spacing Demo */}
        <div className="bg-primary p-custom-6 radius-custom-lg shadow-custom-md">
          <h2 className="text-2xl font-semibold text-primary mb-custom-4">Spacing System</h2>
          
          <div className="space-y-custom-3">
            <div className="flex items-center">
              <div className="bg-brand-primary w-4 h-4 radius-custom-sm mr-custom-1"></div>
              <span className="text-sm text-tertiary">space-1 (4px)</span>
            </div>
            <div className="flex items-center">
              <div className="bg-brand-primary w-4 h-4 radius-custom-sm mr-custom-2"></div>
              <span className="text-sm text-tertiary">space-2 (8px)</span>
            </div>
            <div className="flex items-center">
              <div className="bg-brand-primary w-4 h-4 radius-custom-sm mr-custom-4"></div>
              <span className="text-sm text-tertiary">space-4 (16px)</span>
            </div>
            <div className="flex items-center">
              <div className="bg-brand-primary w-4 h-4 radius-custom-sm mr-custom-6"></div>
              <span className="text-sm text-tertiary">space-6 (24px)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignSystemDemo;
